import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SingleCategorySubcategories } from './SingleCategorySubcategories';
import { useProductCategoriesShortcut } from './useProductCategoriesShortcut';
import Department from '../../../ui/components/Department';

export const ProductCategoriesShortcut = () => {
  const {
    category,
    subcategories,
    isLoadingSubcategories,
    isDropdownOpen,
    setIsDropdownOpen,
  } = useProductCategoriesShortcut();

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      className={`sticky md:top-[4.2rem] top-[7.7rem] z-20 w-full px-5 py-3 overflow-x-auto scrollbar-hide transition-colors duration-300 ${
        scrolled ? 'bg-white/70 backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <div className="flex justify-start gap-5 items-center lg:pb-4">
        <div className="block">
          <Department
            isDropdownOpen={isDropdownOpen}
            setIsDropdownOpen={setIsDropdownOpen}
          />
        </div>

        <ul className="flex space-x-4">
          <SingleCategorySubcategories
            subcategory={subcategories}
            category={category}
            isLoadingSubcategories={isLoadingSubcategories}
          />
        </ul>

        <Link
          to="/sales-offers/"
          className="hidden lg:flex font-medium text-[#DB1C5E] text-sm hover:text-[#FF4A8A] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-pink-400 rounded text-nowrap"
        >
          Sales & Offers
        </Link>
      </div>
    </section>
  );
};
